<template>
  <Modal v-model="choiceDeviceModal" width="1200" footer-hide>
    <p slot="header" class="text-center">添加合同资产</p>
    <Row :gutter="8" class="m-b-5">
      <i-col span="4" class="text-center">
        <RadioGroup v-model="query.deviceBigmodel" @on-change="handleChangeBigModel">
          <Radio :label="3">商业资产</Radio>
          <Radio :label="5">通信资产</Radio>
        </RadioGroup>
      </i-col>
      <i-col span="4">
        <Select
          size="small"
          placeholder="所属资产"
          v-model="query.assetId"
          @on-change="handleChangeAsset"
        >
          <i-option
            v-for="item in assetArray"
            :key="'asset_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <Select
          size="small"
          placeholder="资产类型"
          v-model="query.devicemodel"
          clearable
        >
          <i-option
            v-for="item in childDeviceModelArray"
            :key="'smallmodel_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>
      <i-col span="4">
        <Select
          size="small"
          placeholder="站点（可搜索）"
          filterable
          v-model="query.stationId"
          clearable
        >
          <i-option
            v-for="item in stationArray"
            :key="'qStation_' + item.id"
            :value="item.id"
          >
            {{ item.name }}
          </i-option>
        </Select>
      </i-col>

      <i-col span="6" class="m-b-5">
        <i-input
          size="small"
          v-model="query.keyword"
          placeholder="关键字"
        ></i-input>
      </i-col>
      <i-col span="2">
        <Button
          size="small"
          type="primary"
          icon="ios-search"
          class="m-r-10"
          @click="SearchData"
          >搜索</Button
        >
      </i-col>
    </Row>
    <Table
      size="small"
      :columns="tableColunms"
      :data="tableData"
      :loading="tableLoading"
      stripe
    ></Table>
    <div class="paging_style">
      <Page
        size="small"
        :total="total"
        :page-size="query.pageSize"
        show-total
        show-elevator
        :current="query.pageNumber"
        @on-change="changePage"
      ></Page>
    </div>

    <Spin fix size="large" v-if="spinShow">
        <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
        <div>提交中...</div>
    </Spin>
  </Modal>
</template>

<script>
import { getMaintenanceAssetList, getExistDeviceModelList } from '@/api/rim/asset'
import { getStationByAssetId } from '@/api/rim/station'
import { getEstateDevicePage2 } from '@/api/rim/device'

import { addObjectByDevice } from '@/api/invest/contract'

export default {
  props: {
    contractId: {
      type: Number
    },
    chkDeviceArray: {
      type: Array
    }
  },
  data () {
    return {
      choiceDeviceModal: false,

      assetArray: [],
      parentDeviceModelArray: [],
      childDeviceModelArray: [],
      stationArray: [],

      total: 0,
      query: {
        pageNumber: 1,
        pageSize: 10,
        deviceBigmodel: 3, // 默认值，仅取车站商业
        assetId: undefined,
        devicemodel: undefined,
        stationId: undefined,
        keyword: ''
      },

      tableLoading: false,
      spinShow: false,
      tableData: [],
      tableColunms: [],

      comAssetsColumns: [
        { title: '编号', key: 'code' },
        { title: '类型', align: 'center', key: 'devicemodelName' },
        { title: '站点', align: 'center', key: 'stationName' },
        { title: '出口', align: 'center', key: 'exits' },
        { title: '楼层', align: 'center', key: 'floor' },
        { title: '位置', align: 'center', key: 'positionName' },
        { title: '面积（㎡）', align: 'center', key: 'area' },
        { title: '状态', align: 'center', key: 'enabledName' },
        { title: '经营方', align: 'center', ellipsis: true, tooltip: true, key: 'manageUnitName' },
        {
          title: '租赁类型',
          align: 'center',
          key: 'openLease',
          render: (h, params) => {
            return h('span', params.row.openLease ? '开放租赁' : '自用')
          }
        },
        {
          title: '通电',
          align: 'center',
          key: 'electric',
          render: (h, params) => {
            return h('span', params.row.electric ? '是' : '否')
          }
        },
        {
          title: '通水',
          align: 'center',
          key: 'waterSupply',
          render: (h, params) => {
            return h('span', params.row.waterSupply ? '是' : '否')
          }
        },
        {
          title: '通气',
          align: 'center',
          key: 'gasSupply',
          render: (h, params) => {
            return h('span', params.row.gasSupply ? '是' : '否')
          }
        },
        {
          title: '消防验收',
          align: 'center',
          key: 'fireApproval',
          render: (h, params) => {
            return h('span', params.row.fireApproval ? '是' : '否')
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            let addButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.addDevice(params.row.id)
                  }
                }
              },
              '加入'
            )

            if (this.chkDeviceArray.includes(params.row.id)) {
              addButton = h('span', '-')
            }

            return h('div', [addButton])
          }
        }
      ],

      telecomAssetsColumns: [
        { title: '资产名称', key: 'code' },
        { title: '通信资产类型', key: 'devicemodelName' },
        { title: '所属资产', key: 'assetName' },
        { title: '位置名称', key: 'stationName' },
        { title: '设备位置', key: 'positionName' },
        {
          title: '正线里程(km)',
          key: 'length',
          render: (h, params) => {
            return h('span', params.row.length > 0 ? params.row.length : '-')
          }
        },
        {
          title: '车站建筑面积(㎡)',
          key: 'buildArea',
          render: (h, params) => {
            return h('span', params.row.buildArea > 0 ? params.row.buildArea : '-')
          }
        },
        {
          title: '机房数量(个)',
          key: 'machineNumber',
          render: (h, params) => {
            return h('span', params.row.machineNumber > 0 ? params.row.machineNumber : '-')
          }
        },
        {
          title: '设备点使用面积(㎡)',
          key: 'machineNumber',
          render: (h, params) => {
            return h('span', params.row.useArea > 0 ? params.row.useArea : '-')
          }
        },
        { title: '产权单位', key: 'manageUnitName' },
        { title: '管理单位', key: 'usingUnitName' },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            let addButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.addDevice(params.row.id)
                  }
                }
              },
              '加入'
            )

            if (this.chkDeviceArray.includes(params.row.id)) {
              addButton = h('span', '-')
            }

            return h('div', [addButton])
          }
        }
      ]
    }
  },
  mounted () {
    this.getAssetData()
  },
  methods: {
    showModal () {
      this.initPageData()
      this.tableColunms = this.query.deviceBigmodel === 3 ? this.comAssetsColumns : this.telecomAssetsColumns
      this.choiceDeviceModal = true
    },
    hideModal () {
      this.choiceSpaceModal = false
    },
    initPageData () {
      this.tableLoading = true

      getEstateDevicePage2(this.query).then((response) => {
        this.total = response.totalRow
        this.tableData = response.list
        this.query.pageNumber = response.pageNumber
        this.tableLoading = false
      })
    },

    handleChangeBigModel () {
      this.query.devicemodel = undefined
      this.query.stationId = undefined
      this.tableColunms = this.query.deviceBigmodel === 3 ? this.comAssetsColumns : this.telecomAssetsColumns
      this.SearchData()

      this.handleChangeAsset()
    },
    getAssetData () {
      getMaintenanceAssetList().then(res => {
        if (res && !res.errcode) {
          this.assetArray = res
          this.query.assetId = this.assetArray.length ? this.assetArray[0].id : undefined
          this.handleChangeAsset()
        } else {
          this.assetArray = []
        }
      })
    },
    handleChangeAsset () {
      this.getBigModelData()
      this.getStationData()
    },
    getBigModelData () {
      getExistDeviceModelList({ assetId: this.query.assetId, deviceBigModel: this.query.deviceBigmodel }).then(res => {
        if (res && !res.errcode) {
          this.parentDeviceModelArray = res
          // this.$store.commit('set_big_model_array', this.parentDeviceModelArray)
          // this.query.deviceBigmodel = this.parentDeviceModelArray.length ? this.parentDeviceModelArray[0].id : undefined
          this.handleChangeBigmodel()
        } else {
          this.parentDeviceModelArray = []
        }
      })
    },
    handleChangeBigmodel () {
      const result = this.parentDeviceModelArray.find(x => x.id === this.query.deviceBigmodel)
      this.childDeviceModelArray = result && result.children ? result.children : []
    },
    getStationData () {
      getStationByAssetId({ assetId: this.query.assetId }).then(res => {
        if (res && !res.errcode) {
          const stationType = this.query.deviceBigmodel === 3 ? 1 : 15

          this.stationArray = res.filter(x => x.type === stationType)
        } else {
          this.stationArray = []
        }
      })
    },

    changePage (currentPage) {
      this.query.pageNumber = currentPage
      this.initPageData()
    },
    SearchData () {
      this.query.pageNumber = 1
      this.initPageData()
    },

    addDevice (deviceId) {
      this.spinShow = true
      addObjectByDevice({ deviceId: deviceId, contractId: this.contractId }).then(res => {
        if (res && !res.success) {
          this.$emit('on-success')
          this.$Notice.success({ desc: '添加资产成功！' })
        }

        this.spinShow = false
      })
    }
  }
}
</script>
